import { render, staticRenderFns } from "./DistributorMarginPercent.vue?vue&type=template&id=4a0f153a&scoped=true"
import script from "./DistributorMarginPercent.vue?vue&type=script&lang=ts"
export * from "./DistributorMarginPercent.vue?vue&type=script&lang=ts"
import style0 from "./DistributorMarginPercent.vue?vue&type=style&index=0&id=4a0f153a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0f153a",
  null
  
)

export default component.exports